import $ from "jquery";

// Navigation click handler
$('.js-faq-navigation .faq__navigation-item').on('click', function () {
    const index = $(this).index();

    // Update active state on navigation items
    $('.js-faq-navigation .faq__navigation-item').removeClass('faq__navigation-item--active');
    $(this).addClass('faq__navigation-item--active');

    // Show corresponding FAQ main item
    $('.js-faq-main .faq__main-item').removeClass('faq__main-item--active').eq(index).addClass('faq__main-item--active');
});

// Accordion behavior
$(document).on('click', '.faq__accordion-question', function () {
    const $question = $(this);
    const $item = $question.closest('.faq__accordion-item');
    const $answer = $item.find('.faq__accordion-answer');

    const isActive = $question.hasClass('faq__accordion-question--active');

    // Close all questions
    $item.siblings('.faq__accordion-item').find('.faq__accordion-question').removeClass('faq__accordion-question--active').end().find('.faq__accordion-answer').slideUp();

    // Toggle current question correctly
    if (isActive) {
        // Was open — close it
        $question.removeClass('faq__accordion-question--active');
        $answer.slideUp();
    } else {
        // Was closed — open it
        $question.addClass('faq__accordion-question--active');
        $answer.slideDown();
    }
});